import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENTID;
const packageId = process.env.REACT_APP_PACKAGE_NAME;
const domainHost = domain ? domain.replace(/^https?:\/\//, '') : '';

export const getRedirectUri = () =>
  window?.cordova?.platformId ? `${packageId}://${domainHost}/cordova/${packageId}/callback` : window.location.origin;

export const redirect_uri = getRedirectUri();

export const Auth0ProviderWithHistory = ({ children, history }) => {
  const onRedirectCallback = () => {
    history.replace(window.location.hash + window.location.search);
  };

  return (
    <Auth0Provider
      domain={domainHost}
      clientId={clientId}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
